import FavouriteHeart from '@global/FavouriteHeart'
import IconCamera from '@global/Icons/Camera'
import Image from '@global/Image'
import ListingTags from '@global/ListingCard/ListingTags'
import ShareButton from '@global/ShareButton'
import useBodyClass from '@hooks/useBodyClass'
import { formatDate } from '@lib/date'
import { filterHrefs } from '@lib/helpers'
import { defaultImages } from '@lib/variables'
import { useState } from 'react'
import KeyDetails from '../KeyDetails'
import PropertyAddress from '../PropertyAddress'
import Gallery from './Gallery'
import GalleryMain from './Gallery/GalleryMain'

import * as S from './Photo.styled'

const PropertyPhoto = ({ listing, offmarketUnlocked }) => {
  const [selectedGalleryItem, setSelectedGalleryItem] = useState(null)
  useBodyClass('modal-open', selectedGalleryItem !== null)

  const urls = filterHrefs(
    listing,
    'videos,tours,interactivefloorplans,onlineauctions'
  )
  const { images } = listing
  if (!images || images.length === 0) return null
  let items = listing.images.map((it) => ({
    href: it.image.image_1920_1080,
    link_type: 'image',
  }))

  if (listing.floorplans && listing.floorplans.length > 0) {
    const floorplans = listing.floorplans.map((it) => ({
      href: it.floorplan.floorplan,
      link_type: 'floorplans',
    }))
    items = items.concat(floorplans)
  }

  const remainingPhotos = items.length - 3

  if (urls.videos && urls.videos.length > 0) {
    items = items.concat(
      urls.videos.map((it) => ({
        href: it,
        link_type: 'video',
      }))
    )
  }

  if (urls.tours && urls.tours.length > 0) {
    items = items.concat(
      urls.tours.map((it) => ({
        href: it,
        link_type: 'tour',
      }))
    )
  }

  const floorplanIndex = items.findIndex((it) => it.link_type === 'floorplans')
  const videoIndex = items.findIndex((it) => it.link_type === 'video')
  const virtualTourIndex = items.findIndex((it) => it.link_type === 'tour')
  let thumbnails = []

  if (floorplanIndex > -1) {
    thumbnails = thumbnails.concat([items[floorplanIndex], items[1]])
  } else {
    thumbnails = items.slice(1, 3) // 2 next photo
  }

  return (
    <>
      <S.PropertyPhoto>
        <S.MainPhoto fullwidth={images.length < 2}>
          <GalleryMain
            fullwidth
            items={items}
            address={listing.address_display_string}
            created={listing.created}
            initialSlide={0}
            onImageClick={(key) => setSelectedGalleryItem(key)}
          />
          <FavouriteHeart />
          {items.length > 1 && (
            <S.PropertyPhotoInfo>
              <S.GalleryCount onClick={() => setSelectedGalleryItem(0)}>
                <IconCamera />
                {items.length}
              </S.GalleryCount>
            </S.PropertyPhotoInfo>
          )}
          <ListingTags listing={listing} big />
        </S.MainPhoto>
        {images.length > 1 && (
          <S.Thumbnails>
            {thumbnails.length > 0 &&
              thumbnails.map((thumbnail, key) => (
                <S.Thumbnail
                  key={`thumbnail-${key}`}
                  onClick={() =>
                    thumbnail.link_type === 'floorplans'
                      ? setSelectedGalleryItem(floorplanIndex)
                      : setSelectedGalleryItem(
                          floorplanIndex >= 0 ? key : key + 1
                        )
                  }
                >
                  <Image
                    src={thumbnail.href}
                    fallbackImage={defaultImages.mediumNavy}
                    quickload
                    alt={`${
                      listing.address_display_string || ''
                    } - ${`Thumbnail ${key + 1}`} - ${formatDate(
                      listing.created,
                      'dd/MM/yyyy'
                    )}`}
                  />
                  {remainingPhotos > 0 && key === 1 && (
                    <S.RemainingPhoto>+ {remainingPhotos}</S.RemainingPhoto>
                  )}
                </S.Thumbnail>
              ))}
          </S.Thumbnails>
        )}
      </S.PropertyPhoto>
      {selectedGalleryItem !== null && (
        <Gallery
          items={items}
          listing={listing}
          address={listing.address_display_string}
          created={listing.created}
          floorplanIndex={floorplanIndex}
          videoIndex={videoIndex}
          virtualTourIndex={virtualTourIndex}
          offmarketUnlocked={offmarketUnlocked}
          initialSlide={selectedGalleryItem}
          onClose={() => setSelectedGalleryItem(null)}
          shareInfo={
            <ShareButton
              listing={listing}
              shareInfo={{
                url: listing.url,
                quote: listing.address + ' - ' + listing.headline,
                media: listing.image_url,
                image: listing.image_url,
                subject: 'Check out this property from Barry Plant',
              }}
            />
          }
          propertyInfo={
            <>
              <PropertyAddress
                listing={listing}
                offmarketUnlocked={offmarketUnlocked}
              />
              <S.KeyDetailsWrap>
                <KeyDetails
                  isGalleryView
                  listing={listing}
                  showShareButton={false}
                />
              </S.KeyDetailsWrap>
            </>
          }
        />
      )}
    </>
  )
}

export default PropertyPhoto
